import { render, staticRenderFns } from "./impressions-details.vue?vue&type=template&id=650ebc28&scoped=true&"
import script from "./impressions-details.vue?vue&type=script&lang=js&"
export * from "./impressions-details.vue?vue&type=script&lang=js&"
import style0 from "./impressions-details.vue?vue&type=style&index=0&id=650ebc28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650ebc28",
  null
  
)

export default component.exports